import { CustomElement } from '@aurelia/runtime-html';
import "./unknown-route.scss";
export const name = "unknown-route";
export const template = "<div id=\"unknown-route\">\n    <div class=\"d-flex h-100 flex-column justify-content-center align-items-center\">\n        <article class=\"cont-texts\">\n            <span class=\"not-found d-flex align-items-center\">\n                <cds-icon icon=\"sentiment_very_dissatisfied\" variant=\"outline\"></cds-icon> 404 - Page Not Found\n            </span>\n            <div class=\"d-block line\"></div>\n            <p class=\"unknown-text text-medium font-medium\">${message}</p>\n            <a load=\"route: /; context.bind: null\">\n                <cds-button>Go home</cds-button>\n            </a>\n        </article>\n    </div>\n</div>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
